// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"818":"4a151d50","7520":"4a151d50"}[chunkId] + ".chunk.css";
};